import PropTypes from 'prop-types'
import React, { Component } from 'react'

import styles from './information_center.scss'

let timeout

class InformationCenter extends Component {

	shouldComponentUpdate(nextProps) {
		return nextProps.informationId !== this.props.informationId
	}

	render() {

		clearTimeout(timeout)
		timeout = setTimeout(() => {
			this.props.onInformationClose(this.props.informationId)
		}, this.props.timeout)

		const Information = props => (
			<div className={styles.content}>
				<div className={styles.box}>
					<div className={styles.info}>
						<p>{props.children}</p>
					</div>
				</div>
			</div>
		)

		if (this.props.visible) {
			return (
				<Information {...this.props} />
			)
		} else {
			return null
		}
	}
}

InformationCenter.defaultProps = {
	timeout: 3000,
}

InformationCenter.propTypes = {
	informationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onInformationClose: PropTypes.func,
	timeout: PropTypes.number,
	children: PropTypes.node,
	visible: PropTypes.bool,
}

export default InformationCenter
